import type { UserDetailsResponse, UserDetailsResponseRolesItem } from '@/utils/api/user-service/models'

const ADMIN_ROLES: UserDetailsResponseRolesItem[] = ['ROLE_ADMIN']
const ORGANISATION_ADMIN_ROLES: UserDetailsResponseRolesItem[] = ['ROLE_ORGANIZATION_ADMIN']

function userHasRole(
  user: UserDetailsResponse | null | undefined,
  targetRoles: readonly UserDetailsResponseRolesItem[],
): boolean {
  if (!user?.roles?.length) return false
  return user.roles.some((role) => targetRoles.includes(role))
}

export function isAdminUser(user: UserDetailsResponse | null | undefined): boolean {
  return userHasRole(user, ADMIN_ROLES)
}

export function isOrganisationAdminUser(user: UserDetailsResponse | null | undefined): boolean {
  return userHasRole(user, ORGANISATION_ADMIN_ROLES)
}
